import { render, staticRenderFns } from "./FixOrQuantity.vue?vue&type=template&id=aee68854"
import script from "./FixOrQuantity.vue?vue&type=script&lang=js"
export * from "./FixOrQuantity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports